<template lang="pug">
modal-dialog(modal-scale="large")
  .modal-card(slot="card")
    .outter
      .plain-text 请输入第三方平台订单信息
      .flex
        span 核销码
        .input
          custom-input(
            v-model="write_code",
            placeholder="请输入第三方平台订单核销码",
            need-type="number_letter"
          )
      .btns
        button.button.large.close(@click="closeModal") 取消
        button.button.large.primary.search(@click="search") 核销
</template>

<script>
import ModalDialog from '@/components/generics/ModalDialog'
import modalInteractions from '@/mixins/utilities/modalInteractions'
import workbenchMixin from '@/mixins/modules/workbench'
import CustomInput from '@/components/generics/form/CustomInput'
export default {
  name: 'ThirdSearchModal',
  mixins: [modalInteractions, workbenchMixin],
  components: {
    ModalDialog,
    CustomInput,
  },
  data () {
    return {
      order_no: '',
      write_code: '',
    }
  },
  methods: {
    closeModal () {
      console.log('closing')
      this.modalClose()
    },
    search () {
      if (!this.write_code) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '提示',
          autoClose: true,
          content: '请输入核销码',
        })
        return
      }
      let arr = [10, 11, 8, 9]
      // if (this.write_code.length !== 10 && this.write_code.length !== 11) {
      if (!arr.includes(this.write_code.length)) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '无效核销码',
          primary: '关闭',
          autoClose: false,
          content: '该核销码不存在，请确认核销码和门店是否正确！',
        })
        return
      }
      this.$emit('confirm', { write_code: this.write_code })
      this.modalClose()
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@/stylus/mixins.styl'
.outter
  background-color rgb(242, 242, 242)
  .plain-text
    padding 20px 0 20px 15px
    font-size 18px
    margin 15px 0
    border-bottom 1px solid rgba(0, 0, 0, 0.08)
  .flex
    margin-left 45px
    margin-top 20px
    display flex
    align-items center
    .input
      padding 0 15px
      width 450px
  .btns
    padding 25px 0
    display flex
    align-items center
    justify-content center
    .button
      margin 0 15px
      width 150px
</style>



// WEBPACK FOOTER //
// src/components/workbench/model/ThirdSearchModal.vue